import React, { useEffect, useState } from 'react';
import './BunsRewardPopup.css';

/**
 * BunsRewardPopup - BUNS reward popup animation component
 * Inspired by mainstream Apps (Alipay/WeChat/Games) reward popup effects
 *
 * @param {boolean} show - Whether to show
 * @param {number} bunsAmount - Amount of BUNS earned
 * @param {string} rewardType - Reward type code
 * @param {string} sourceDetail - Reward source description
 * @param {number} newBalance - Total balance after earning
 * @param {function} onClose - Close callback
 */
class BunsRewardPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phase: props.show ? 'appear' : 'hidden',
        };
    }

    componentDidMount() {
        if (this.props.show) {
            this.startAnimation();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
            this.setState({ phase: 'appear' }, () => {
                this.startAnimation();
            });
        }
    }

    startAnimation() {
        this.setState({ phase: 'appear' });

        // Bounce in animation
        setTimeout(() => this.setState({ phase: 'bounce' }), 100);
        setTimeout(() => this.setState({ phase: 'settle' }), 600);
        // Falling coins animation
        setTimeout(() => this.setState({ phase: 'coins' }), 800);
    }

    handleClose = () => {
        this.setState({ phase: 'fade' });
        setTimeout(() => {
            if (this.props.onClose) this.props.onClose();
        }, 400);
    };

    getRewardMessage = () => {
        const { rewardType } = this.props;
        const messages = {
            first_register: '🎉 Welcome to BaoBounty!',
            extra_question: '📝 Answered Extra Question',
            daily_login: '🥟 Daily Login Reward',
            watched_ad: '📺 Ad Watch Reward',
            reply_match: '💬 Reply Match Reward',
            referral_bonus: '👥 Successful Referral!',
            weekly_quiz: '🧠 Weekly Quiz Complete!',
        };
        return messages[rewardType] || '✨ BUNS Reward Earned!';
    };

    render() {
        const { show, bunsAmount, newBalance } = this.props;
        const { phase } = this.state;

        if (!show && phase === 'hidden') return null;

        const phaseClass = phase === 'hidden' ? '' : `bunsPopupOverlay--${phase}`;

        // Generate falling coins
        const coins = [];
        if (phase === 'coins' || phase === 'settle') {
            for (let i = 0; i < 12; i++) {
                coins.push(
                    <div
                        key={i}
                        className="bunsCoin"
                        style={{
                            left: `${10 + (i * 8) % 80}%`,
                            animationDelay: `${i * 0.1}s`,
                            animationDuration: `${1.5 + Math.random() * 0.5}s`,
                        }}
                    >
                        🪙
                    </div>
                );
            }
        }

        return (
            <div className={`bunsPopupOverlay ${phaseClass}`} onClick={this.handleClose}>
                <div className="bunsPopupCard" onClick={(e) => e.stopPropagation()}>
                    {/* Glow effect */}
                    <div className="bunsGlow"></div>

                    {/* BUNS amount */}
                    <div className="bunsAmountWrap">
                        <span className="bunsIcon">🪙</span>
                        <span className="bunsAmountNum">+{bunsAmount}</span>
                        <span className="bunsLabel">BUNS</span>
                    </div>

                    {/* Reward message */}
                    <p className="bunsMessage">{this.getRewardMessage()}</p>
                    {this.props.sourceDetail && (
                        <p className="bunsSourceDetail">{this.props.sourceDetail}</p>
                    )}

                    {/* New balance */}
                    {newBalance !== undefined && (
                        <div className="bunsNewBalance">
                            <span>Current Balance</span>
                            <span className="bunsBalanceNum">{newBalance}</span>
                        </div>
                    )}

                    {/* Close button */}
                    <button className="bunsCloseBtn" onClick={this.handleClose}>
                        Awesome!
                    </button>
                </div>

                {/* Falling coins */}
                {coins}
            </div>
        );
    }
}

export default BunsRewardPopup;
